/**
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║  SCROLL ANIMATIONS JS - RARCO LIFESTYLE                                    ║
 * ║  Performance Optimized Intersection Observer                              ║
 * ║  Developer: IntellectSight (https://intellectsight.com/)                  ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 */

(function() {
  'use strict';

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (prefersReducedMotion) {
    // Show all elements immediately for users who prefer reduced motion
    document.querySelectorAll('[data-scroll-animate]').forEach(el => {
      el.classList.add('scroll-animated');
    });
    return;
  }

  // Intersection Observer options
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -80px 0px',
    threshold: 0.1
  };

  // Create observer
  const scrollObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add animated class
        entry.target.classList.add('scroll-animated');
        
        // If element has stagger children, animate them too
        if (entry.target.hasAttribute('data-scroll-stagger')) {
          const children = entry.target.children;
          Array.from(children).forEach(child => {
            child.classList.add('scroll-animated');
          });
        }
        
        // Unobserve after animation (one-time animation)
        if (!entry.target.hasAttribute('data-scroll-repeat')) {
          observer.unobserve(entry.target);
        }
      } else {
        // If repeat is enabled, remove class when out of view
        if (entry.target.hasAttribute('data-scroll-repeat')) {
          entry.target.classList.remove('scroll-animated');
        }
      }
    });
  }, observerOptions);

  // Observe all elements with scroll animation
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-scroll-animate]');
    
    animatedElements.forEach(el => {
      scrollObserver.observe(el);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations);
  } else {
    initScrollAnimations();
  }

  // Re-initialize for dynamically added content
  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          // Check if the added node has scroll animation
          if (node.hasAttribute && node.hasAttribute('data-scroll-animate')) {
            scrollObserver.observe(node);
          }
          // Check children
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-scroll-animate]').forEach(el => {
              scrollObserver.observe(el);
            });
          }
        }
      });
    });
  });

  // Observe document body for dynamic content
  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Expose function globally for manual triggering
  window.initScrollAnimations = initScrollAnimations;
})();
